// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorStatistics = (client) => ({
    /**
     * `GET /vendor/statistics`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetStoreStatistics
     * @source packages/modules/b2c-core/src/api/vendor/statistics/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/statistics", { method: "GET", query, headers }),
});
//# sourceMappingURL=statistics.js.map